export const saloon_view01ImageOptions = {
  angle: 'Saloon_view01',
  staticOptions: {
    Handrail: 1,
    Worktop: 1,
    SaloonPouffe: 1,
    SaloonBackRest: 1,
    CupboardsSaloon: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    beautytable: 1,
    LargeWardrobe: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1,
    LeatherHandles: 1
  },
  mattes: [
    {
      option: 'Worktop',
      dependency: 'GalleyLayout'
    },
    {
      option: 'SaloonPouffe',
      dependency: 'Veneer'
    },
    {
      option: 'SaloonBackRest',
      dependency: 'Fabric'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    },
    {
      option: 'CupboardsOwnersCabin',
      dependency: 'Veneer'
    },
    {
      option: 'Mast',
      dependency: null
    },
    {
      option: 'LeatherHandles',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/Saloon_view01.js